import ControlsFiltersTypes from './ControlsFiltersTypes';
import { useUrlParams } from '../../hooks';

const ControlsFilters = () => {

  const { tab } = useUrlParams();

  if (tab === 'verifiers') {
    return <ControlsFiltersTypes />;
  }

  return <></>;

};

export default ControlsFilters;
